/** Русский. See `en.ts` for what each key is and what it has to fit.
 *
 * The rail glyphs stay on the Latin WMO symbols — they are symbols, not
 * words, and a Cyrillic transliteration would not be one. The pressure
 * centers do have a Russian chart convention, В / Н (высокое / низкое), and
 * take it. */

import type { MessageKey } from "./en";

export const ru: Record<MessageKey, string> = {
  metaDescription:
    "Бесплатные карты погоды в реальном времени в браузере: прогнозы GFS, ECMWF и AIFS, анимации радаров и спутников, траектории тайфунов, 3D-радар и диаграммы skew-T.",
  pageTitleLive: "Прогностическая карта: {variable} · {model} {hours}H",
  pageTitleLiveObservation: "Карта наблюдений: {variable} · {model} · последние {hours} ч",
  mapAria: "Глобальная карта прогноза температуры и осадков",
  modelSwitchAria: "Набор данных",
  variableSwitchAria: "Метеорологическая величина",
  varTemp: "2 М",
  varPrecip: "ИНТЕНС",
  varWind: "10 М",
  varSolar: "ПОТОК",
  varRadar: "CREF",
  varOrog: "OROG",
  varInfrared: "ИК 10,4",
  varShortwave: "ИК 3,9",
  varDustRgb: "RGB",
  varDustCf: "DEBRA",
  varZhouye: "ZHOUYE",
  varTrueColor: "ЦВЕТ",
  varGust: "ПОРЫВ",
  varCloud: "ОБЩАЯ",
  varCape: "У ЗЕМЛИ",
  varPwat: "СТОЛБ",
  varPtype: "ТИП",
  varCin: "ТОРМ",
  varHpbl: "ВЫСОТА",
  varVis: "ВИДИМ",
  varDewPoint: "2М",
  varFeelsLike: "2М",
  varOmega: "ВЕРТ",
  varThetaE: "ЭКВИВ",
  varCat: "EDR",
  varInflow: "ПОТОК",
  varFront: "ФРОНТ",
  varHotspot: "ОЧАГИ",
  varFfwi: "ПОЖ. ПОГОДА",
  varFwalert: "ТРЕВОГА",
  varSst: "ПОВЕРХ.",
  varIce: "СПЛОЧ.",
  varWave: "ВЫСОТА",
  varAod: "ОБЩАЯ",
  varPm: "2.5",
  varDustsfc: "У ЗЕМЛИ",
  varTsoil: "СЛОЙ 1",
  varSoilw: "СЛОЙ 1",
  varHumidity: "ОТН",
  varVapourFlux: "ПОТОК",
  varPressure: "УР МОРЯ",
  varHeight: "ВЫСОТА",
  varPressureField: "ПОЛЕ",
  varUnknownLayer: "СЛОЙ",

  glyphTmp2m: "T",
  glyphPrate: "R",
  glyphWind10m: "W",
  glyphDswrf: "S",
  glyphCref: "Z",
  glyphIr104: "С",
  glyphIr039: "К",
  glyphDustrgb: "П",
  glyphDustcf: "У",
  glyphZhouye: "Z",
  glyphTruecolor: "Ц",
  glyphGust: "G",
  glyphTcdc: "N",
  glyphCape: "C",
  glyphVis: "V",
  glyphPwat: "P",
  glyphCin: "I",
  glyphHpbl: "B",
  glyphPtype: "Y",
  glyphDpt2m: "D",
  glyphAptmp2m: "A",
  glyphVvel: "ω",
  glyphThetae: "θ",
  glyphCat: "ε",
  glyphInflow: "В",
  glyphFront: "Ф",
  glyphHotspot: "О",
  glyphFfwi: "П",
  glyphFwalert: "Т",
  glyphTmpsfc: "S",
  glyphIce: "I",
  glyphWave: "H",
  glyphAod: "τ",
  glyphPm: "µ",
  glyphDustsfc: "П",
  glyphTsoil: "E",
  glyphSoilw: "M",
  glyphPressure: "P",
  glyphRh: "U",
  glyphQflux: "F",
  tipTemp: "Температура",
  tipHumidity: "Относительная влажность",
  tipWind: "Ветер",
  tipPressure: "Давление и геопотенциальная высота",
  tipVapourFlux: "Поток водяного пара",
  tipCloud: "Облачность",
  tipOmega: "Вертикальная скорость",
  tipThetaE: "Эквивалентно-потенциальная температура",
  tipCat: "Турбулентность ясного неба",
  tipIce: "Морской лёд",
  tipWave: "Волнение",
  tipAod: "Аэрозольная оптическая толщина",
  tipPm: "Взвешенные частицы",
  tipTsoil: "Температура почвы",
  tipSoilw: "Влажность почвы",
  tipSatellite: "Спутниковый снимок",
  levelSwitchAria: "Уровень",
  levelCaption: "Уровень",
  linesCaption: "Изолинии",
  accumCaption: "Сумма",
  accumRateGloss: "интенсивность",
  accumTotalGloss: "сумма за {window}",
  modelHeading: "Наборы данных",
  linesRemoveTitle: "Нажмите ещё раз, чтобы убрать изолинии",
  fieldSectionAria: "Поле",
  overlaySectionAria: "Наложения",
  markSectionAria: "Метки",
  tipMore: "Все слои этого прогона",
  varMore: "Слои",
  glyphMore: "+",
  fieldSheetAria: "Слои",
  fieldSheetHeading: "Слои",
  fieldGroupTemperature: "Температура",
  fieldGroupMoisture: "Влага",
  fieldGroupSoil: "Почва",
  fieldGroupWind: "Ветер",
  fieldGroupDynamics: "Динамика",
  fieldGroupRadiation: "Радиация и видимость",
  fieldGroupAerosol: "Аэрозоли и качество воздуха",
  fieldGroupOcean: "Океан",
  fieldGroupHydrology: "Реки и паводки",
  fieldGroupSatellite: "Спутник",
  fieldGroupOther: "Прочее",
  fieldGroupImagery: "Суточные снимки: NASA GIBS",
  gibsTrueColor: "ЕСТ.",
  gibsFalseColor: "ПОЖАР",
  gibsTipTrue: "Естественные цвета",
  gibsTipFire: "Ложные цвета для пожаров: гари тёмно-красные",
  varParticles: "ПОТОК",
  glyphParticles: "≈",
  varVolume: "3D-ОБЛАКО",
  glyphVolume: "Q",
  levelAlone: "Только линии",
  levelAloneTitle: "Только линии: поле убирается, повторное нажатие возвращает его",
  creditsTrigger: "Источники",
  creditsHeading: "Данные и благодарности",
  creditsGfs: "Прогностические данные: GFS 0.25° и sflux",
  creditsHrrr: "Прогностические данные: HRRR 3 км, континентальные США",
  creditsGefsAero: "Прогноз аэрозолей: GEFS-Aerosols 0,25°, АОТ и приземные частицы",
  creditsCmaDust: "Прогноз пыли: CMA-CW v1.0/DUST (WMO SDS-WAS Asian Center) 0,15° над Азией, через WMO WIS2",
  creditsSilam: "Прогноз качества воздуха: FMI SILAM v6.1, глобально, 0,2°, CC BY 4.0",
  creditsCfs: "Сезонный прогноз: CFSv2, 9 месяцев, каждые 6 часов",
  creditsEcmwf: "Содержит изменённые данные ECMWF, CC BY 4.0",
  creditsIfsHres: "Адаптировано из ECMWF IFS центром ECMWF, лицензия CC BY 4.0; через Open-Meteo; IFS HRES ~9 км, пересэмплировано до 0,1°",
  creditsMrms: "Радарные наблюдения: MRMS, континентальные США",
  creditsNexrad: "Отдельные радары: отражаемость и радиальная скорость, США",
  creditsJma: "Радарные осадки: наукаст JMA, Япония (пересетка)",
  creditsHimawari: "Спутниковые снимки: Himawari-9 AHI, JMA, через NOAA Open Data (перепроецировано)",
  creditsGoes: "Спутниковые снимки: GOES-19 Восток и GOES-18 Запад ABI, NOAA NESDIS, через NOAA Open Data (перепроецировано)",
  creditsMeteosat: "Спутниковые снимки: содержит изменённые данные EUMETSAT Meteosat {year}; Meteosat-12 FCI, ежечасный цикл, CC-BY-4.0 (перепроецировано)",
  creditsSounding: "Радиозондирование: GTS TEMP через WIS2, национальные метеослужбы",
  creditsAirport: "METAR и TAF аэропортов: метеослужбы мира через NOAA/NWS AWC",
  creditsFirms: "Активные пожары: LANCE FIRMS NRT, VIIRS 375 м и MODIS, NASA ESDIS",
  creditsGibs: "Ежедневные снимки: исправленное отражение MODIS и VIIRS, NASA ESDIS",
  creditsRadar: "Радарная мозаика",
  creditsBasemap: "Подложка: © участники OpenStreetMap",
  creditsTerrain: "Рельеф: © Mapterhorn, источники данных о высотах",
  creditsPeaks: "Названия и высоты вершин: CC0",
  creditsCode: "Исходный код: ringsaturn/xue",
  caseTag: "Случай",
  caseSummaryAria: "Описание случая",
  runCycle: "Исходный срок",
  recordSpan: "Период ряда",
  latestObservation: "Последнее наблюдение",
  latestNowcast: "Последний наукаст",
  awaitingData: "Ожидание данных",
  validTimeLabel: "Время прогноза",
  observationTimeLabel: "Время наблюдения",
  statsAria: "Подробная статистика",
  statsCloseAria: "Закрыть статистику",
  bufferedFrames: "В буфере",
  downloadedBytes: "Загружено",
  formatLabel: "Формат",
  formatZarr: "Zarr",
  preloadProgressAria: "Ход предварительной загрузки прогностических данных",
  statDataset: "Набор данных",
  statGrid: "Сетка",
  statFrameCache: "Кеш кадров",
  statDecodeTime: "Время декодир.",
  statDecodeRate: "Скорость декодир.",
  statViewport: "Выборка области",
  statConnection: "Соединение",
  awaitingManifest: "Ожидание манифеста",
  legendPrateAria: "Цветовая шкала интенсивности осадков",
  timelineAria: "Управление временем прогноза",
  playAnimation: "Запустить анимацию",
  pauseAnimation: "Приостановить анимацию",
  playbackSpeed: "Скорость воспроизведения",
  exportOpenAria: "Экспорт анимации",
  exportSheetAria: "Экспорт анимации",
  exportHeading: "Экспорт",
  exportFormat: "Формат",
  exportSize: "Размер",
  exportFps: "Частота кадров",
  exportRange: "Кадры",
  exportFrom: "С",
  exportTo: "По",
  exportRun: "Экспортировать",
  exportCancel: "Отмена",
  exportSummary: "{size}, {frames} кадров, {seconds} с, около {bytes}",
  exportCapturing: "Захват {done}/{total}",
  exportEncoding: "Кодирование {percent}%",
  exportFailed: "Ошибка экспорта",
  readingManifest: "Загрузка манифеста",
  forecastHourAria: "Час прогноза",
  forecastDaysAria: "Суточные отрезки прогноза",
  observationDaysAria: "Суточные отрезки",
  mapMenuAria: "Параметры карты",
  menuStats: "Подробная статистика",
  menuCopyDebug: "Скопировать отладочные сведения",
  errorTitle: "Данные недоступны",
  retry: "Повторить",
  langPickerAria: "Язык",
  langPickerHeading: "Язык",
  themeToggleAria: "Переключить светлое / тёмное",
  viewGlobeAria: "Глобус",
  viewTerrainAria: "3D-рельеф",
  viewContoursAria: "Горизонтали",
  viewResetNorthAria: "Сбросить на север",
  viewResetPitchAria: "Сбросить наклон",
  viewBoxAria: "Шторм крупным планом: выделите рамкой",
  viewSectionAria: "Вертикальный разрез: проведите линию",
  viewDistanceAria: "Измерить расстояние: щёлкайте точки, повторный щелчок по последней — конец",
  viewAreaAria: "Измерить площадь: щёлкайте вершины, повторный щелчок по первой или последней — конец",
  particlesToggle: "Частицы",
  particlesToggleAria: "Включить или выключить анимацию частиц ветра",

  dataInterrupted: "Загрузка данных прервана",
  errorHint: "{message}. Убедитесь, что выполнена команда make mvp и страница открыта через make serve.",
  loadFailed: "Ошибка загрузки",
  webglLost: "WebGL недоступен: полностью закройте браузер и откройте его снова",
  saveData: "экономия",
  debugCopied: "Отладочные сведения скопированы",
  copyFailed: "Не удалось скопировать",
  bundleResident: "Пакет полностью в памяти",
  viewportResident: "Текущая область полностью загружена",
  streamingOnDemand: "Потоковая загрузка по требованию",
  receivingBundle: "Приём прогностического пакета",
  receivingBundlePercent: "Приём пакета {percent}%",
  readingIndex: "Чтение индекса данных",
  initializingDecoder: "Инициализация декодера",
  framesReady: "Кадров готово: {count}",
  readingData: "Загрузка данных",
  bundleLoadFailed: "Не удалось загрузить прогностический пакет",
  workerStartFailed: "Не удалось запустить воркер декодирования",
  decodeFailed: "Ошибка декодирования",
  frameDecodeFailed: "Ошибка декодирования кадра: {message}",
  legendAria: "Цветовая шкала: {label}",
  legendInflow: "Тёплый влажный поток",
  legendFront: "Фронтальная зона (градиент θe)",
  legendHotspot: "Термоточка (контекстный тест 3,9 мкм)",
  legendFfwi: "Индекс пожарной погоды Фосберга",
  legendFwalert: "Относительная влажность ниже 30 % при порывах от 10 м/с",
  legendDustDust: "Пыль",
  legendDustThickHigh: "Плотная верхняя облачность",
  legendDustThinHigh: "Тонкая верхняя облачность",
  legendDustMid: "Средняя облачность",
  legendDustLow: "Тёплая нижняя облачность",
  legendDustDesert: "Горячая поверхность пустыни",
  legendDustSurface: "Море и растительность",
  legendTruecolorCloud: "Облака и снег",
  legendTruecolorSea: "Море",
  legendTruecolorLand: "Суша и растительность",
  legendTruecolorNightCloud: "Облачность ночью (ИК)",
  legendTruecolorNightGround: "Ясно ночью",
  legendPtypeRain: "Дождь",
  legendPtypeFreezingRain: "Ледяной дождь",
  legendPtypeSnow: "Снег",
  legendPtypeIcePellets: "Ледяные гранулы",
  legendDisrpBelow: "Ниже уровня 1,5 года",
  legendDisrp1p5: "≥ уровня 1,5 года",
  legendDisrp2: "≥ уровня 2 лет",
  legendDisrp5: "≥ уровня 5 лет",
  legendDisrp20: "≥ уровня 20 лет",
  legendCatLight: "Слабая",
  legendCatModerate: "Умеренная",
  legendCatModerateSevere: "Умеренная–сильная",
  legendCatSevere: "Сильная",
  varLabelTmp2m: "Температура на 2 м",
  varLabelPrate: "Интенсивность осадков",
  varLabelDswrf: "Солнечная радиация",
  varLabelWind10m: "Ветер на 10 м",
  varLabelWind80m: "Ветер на 80 м",
  varLabelWind100m: "Ветер на 100 м",
  varLabelCref: "Составная радиолокационная отражаемость",
  varLabelRefl3d: "Трёхмерная радиолокационная отражаемость",
  varLabelCloud3d: "Трёхмерная облачная вода",
  varLabelOrog: "Орография",
  varLabelIr104: "Инфракрасный снимок (яркостная температура 10,4 мкм)",
  varLabelIr039: "Коротковолновый ИК (яркостная температура 3,9 мкм)",
  varLabelDustrgb: "Пылевой RGB (инфракрасный композит)",
  varLabelDustcf: "Уверенность DEBRA в пыли",
  varLabelZhouye: "Уверенность ZHOUYE в пыли",
  varLabelTruecolor: "Естественные цвета днём, ИК-облачность ночью",
  varLabelGust: "Порывы ветра",
  varLabelTcdc: "Общая облачность",
  varLabelCape: "Доступная потенциальная энергия конвекции",
  varLabelCin: "Конвективное торможение",
  varLabelVis: "Видимость",
  varLabelDpt2m: "Точка росы на 2 м",
  varLabelAptmp2m: "Ощущаемая температура на 2 м",
  varLabelLcdc: "Нижняя облачность",
  varLabelMcdc: "Средняя облачность",
  varLabelHcdc: "Верхняя облачность",
  varLabelPwat: "Осаждаемая вода",
  varLabelHpbl: "Высота планетарного пограничного слоя",
  varLabelPtype: "Тип осадков",
  varLabelTmpsfc: "Температура поверхности моря (над сушей — поверхности земли)",
  varLabelIcec: "Сплочённость морского льда",
  varLabelIcetk: "Толщина морского льда",
  varLabelWave: "Волнение: значительная высота и направление",
  varLabelHtsgw: "Значительная высота волн",
  varLabelPerpw: "Период основной волны",
  varLabelDirpw: "Направление основной волны",
  varLabelWindwave: "Ветровые волны: значительная высота и направление",
  varLabelSwell: "Зыбь: значительная высота и направление (первая составляющая)",
  varLabelWvhgt: "Значительная высота ветровых волн",
  varLabelWvper: "Средний период ветровых волн",
  varLabelWvdir: "Направление ветровых волн",
  varLabelSwhgt: "Значительная высота зыби (первая составляющая)",
  varLabelSwper: "Средний период зыби (первая составляющая)",
  varLabelSwdir: "Направление зыби (первая составляющая)",
  varLabelAod: "Аэрозольная оптическая толщина на 550 нм",
  varLabelAoddust: "Оптическая толщина пыли",
  varLabelAodsalt: "Оптическая толщина морской соли",
  varLabelAodsulf: "Оптическая толщина сульфатов",
  varLabelAodorg: "Оптическая толщина органического углерода",
  varLabelAodbc: "Оптическая толщина чёрного углерода",
  varLabelPm25: "Приземная концентрация PM2,5",
  varLabelPm10: "Приземная концентрация PM10",
  varLabelPm10dust: "Приземная концентрация пылевого PM10",
  varLabelDustsfc: "Приземная концентрация пыли",
  varLabelTsoil1: "Температура почвы, слой 1",
  varLabelTsoil2: "Температура почвы, слой 2",
  varLabelTsoil3: "Температура почвы, слой 3",
  varLabelTsoil4: "Температура почвы, слой 4",
  varLabelSoilw1: "Объёмная влажность почвы, слой 1",
  varLabelSoilw2: "Объёмная влажность почвы, слой 2",
  varLabelSoilw3: "Объёмная влажность почвы, слой 3",
  varLabelSoilw4: "Объёмная влажность почвы, слой 4",
  varLabelPrmsl: "Давление на уровне моря",
  varLabelHeightAtLevel: "Геопотенциальная высота {level} гПа",
  varLabelTempAtLevel: "Температура {level} гПа",
  varLabelRhAtLevel: "Относительная влажность {level} гПа",
  varLabelSpfhAtLevel: "Удельная влажность {level} гПа",
  varLabelWindAtLevel: "Ветер {level} гПа",
  varLabelQfluxAtLevel: "Поток водяного пара {level} гПа",
  varLabelVvelAtLevel: "Вертикальная скорость на {level} гПа",
  varLabelThetaeAtLevel: "Эквивалентно-потенциальная температура на {level} гПа",
  varLabelCatAtLevel: "Турбулентность ясного неба на {level} гПа (EDR)",
  legendSubtropicalHigh: "изогипса 588",
  webglUnavailable: "Этот браузер не предоставляет контекст WebGL2",
  pointerRequestFailed: "Запрос указателя вернул HTTP {status}",
  manifestRequestFailed: "Запрос манифеста вернул HTTP {status}",
  bundleRequestFailed: "Запрос пакета вернул HTTP {status}",
  bundleTooLong: "Пакет длиннее, чем объявлено в манифесте",
  bundleLengthMismatch: "Длина пакета не совпадает с манифестом",
  bundleChecksumMismatch: "Контрольная сумма пакета не совпадает",
  bundleRunMismatch: "Исходный срок пакета не совпадает с манифестом",
  bundleMissingVariable: "В пакете нет величины {id}",
  manifestMissingBundle: "В манифесте нет пакета для величины {id}",
  mosaicNoMembers: "Ни один спутниковый набор данных мозаики недоступен",

  probeAria: "Временной ряд в точке",
  probeHint: "Запустите воспроизведение или перетащите ползунок, чтобы заполнить ряд",
  probeComplete: "Ряд заполнен",
  probeOutside: "Точка вне сетки этого набора данных",
  probeNoData: "В этом кадре нет данных",
  probeAwaiting: "Ожидание этого кадра",
  probeModelElevationLabel: "Модель",
  probeDemLabel: "DEM",
  probeCloseAria: "Закрыть данные точки",
  cardCloseAria: "Закрыть карточку",

  centerHigh: "В",
  centerLow: "Н",

  showcaseLink: "Случаи",
  showcaseBack: "← Все случаи",
  showcaseHome: "Текущий прогноз",
  showcaseTitle: "Архивные случаи",
  showcaseHeading: "Погодные события в записи",
  showcaseArchive: "архив",
  showcaseIntro:
    "Каждый случай — срез одного прошедшего погодного события: архивный прогностический срок или наблюдения, пропущенные через тот же кодировщик и обрезанные до района и часов, в которые всё происходило.",
  showcaseMetaDescription:
    "Повторы прошедших погодных событий: обрезанные наборы прогностических и радарных данных по тайфунам, ливням, волнам жары и другому",
  showcaseLoading: "Загрузка каталога случаев",
  showcaseEmpty: "Случаи пока не опубликованы",
  showcaseLoadFailed: "Не удалось загрузить каталог случаев: {message}",
  showcaseCaseMissing: "Случая с именем {id} нет",
  showcaseEventLabel: "Событие",
  showcaseRunLabel: "Выпуск",
  showcaseSeriesLabel: "Начало",
  showcaseRangeLabel: "Срок",
  showcaseSpanLabel: "Период",
  showcaseRegionLabel: "Район",
  showcaseGridLabel: "Сетка",
  showcaseSizeLabel: "Объём",
  showcaseVariablesLabel: "Поля",
  showcaseHours: "{count} ч",
  showcaseCaseAria: "Открыть случай {title}",
  showcaseListAria: "Список архивных случаев",

  tcTileTip: "Тропические циклоны",
  varTc: "ТРЕК",
  glyphTc: "C",
  tcSheetAria: "Тропические циклоны",
  tcHeading: "Тропические циклоны",
  tcAllSystems: "Все пронумерованные системы",
  tcNone: "Активных систем нет",
  tcUnnamed: "Безымянная система",
  tcDisturbances: "Возмущения и депрессии",
  tcPotential: "Возможные системы",
  tcPotentialShow: "Показать {count} систем, найденных только моделями",
  tcModelOnly: "только модель",
  tcAgencies: "Официальные прогнозы",
  tcModels: "Треки моделей",
  tcMembers: "Члены ансамбля",
  tcBest: "Лучший трек",
  tcOptionsAria: "Настройки циклонов",
  tcHistoryHeading: "Прошлые тропические циклоны",
  tcHistoryIntro: "Каждый пронумерованный шторм архива: лучшие треки центров, каждый прогноз, выпущенный для него, и насколько каждый ошибся.",
  tcHistorySeasonsAria: "Сезон",
  tcHistoryBasinsAria: "Бассейн",
  tcHistoryAll: "Все",
  tcHistoryEmpty: "В этом сезоне и бассейне нет штормов с прогнозами",
  tcHistoryStormAria: "Открыть {name}",
  tcHistorySouthernNote: "Сезоны Южного полушария длятся с июля по июнь и называются по году окончания: сезон {season} — с {from} по {to}.",
  tcPageTitle: "Прошлый тропический циклон",
  tcPageMetaDescription: "Прошлый тропический циклон: лучшие треки центров, все архивные прогнозы для него и насколько каждый ошибся.",
  tcPageLoading: "Загрузка шторма",
  tcPageMissing: "В архиве нет шторма {id}",
  tcPageFailed: "Не удалось загрузить шторм: {message}",
  tcPageIssue: "Время",
  tcPageNoForecast: "прогнозов с этого срока нет",
  tcPagePrev: "Предыдущий прогноз",
  tcPageNext: "Следующий прогноз",
  tcPageSources: "Показанные треки",
  tcPageErrorsHeading: "Ошибка трека, км",
  tcPageTruth: "Относительно лучшего трека",
  tcPageSource: "Источник",
  tcPageErrorsMean: "Среднее по шторму",
  tcPageErrorsThis: "Прогноз на карте",
  tcPageErrorsNone: "Ни один прогноз этого шторма ещё не сверен с этим лучшим треком",
  tcPageNote: "Расстояние до лучшего трека в синоптические сроки, только пока система является тропическим или субтропическим циклоном; ансамбль оценивается по среднему. Официальные прогнозы стоят рядом с моделями того же срока запуска, которые завершились уже после выпуска официального прогноза.",
  tcPageId: "Номер ATCF",
  tcPageLife: "Время жизни",
  tcPagePeak: "Пиковый ветер",
  tcPageForecasts: "Прогнозы",
  tcCardSeasons: "Сезоны",
  tcCardStorms: "Штормы",
  tcPageDetails: "Страница шторма",
  tcPageSeasonList: "Все штормы сезона",
  tcCardBrowse: "По сезонам",
  tcPageRadii: "Радиусы ветра",
  tcLegendIntensity: "Интенсивность: лучший трек США, ветер за 1 мин",

  soundingTileTip: "Радиозондирование",
  varSounding: "ВЫСОТА",
  glyphSounding: "S",
  airportTileTip: "Наблюдения аэропортов",
  varAirport: "METAR",
  glyphAirport: "A",
  synopTileTip: "Наземные метеостанции",
  varSynop: "ПРИЗЕМН.",
  glyphSynop: "W",
  radarTileTip: "Отдельный радар",
  varRadarSite: "РАДАР",
  glyphRadarSite: "D",
  radarProductAria: "Продукт радара",
  radarLatest: "последний",
  radarCloseAria: "Назад к мозаике",
  radarReflectivity: "Отражаемость",
  radarVelocity: "Радиальная скорость",
  stationSounding: "Зондирование",
  stationAirport: "Аэропорт",
  stationObserved: "Наблюдение",
  stationFreezingLevel: "Нулевая изотерма",
  stationPw: "Влагозапас",
  stationCategory: "Категория полётов",
  stationVisibility: "Видимость",
  stationQnh: "QNH",
  stationLevels: "Уровни",
  stationSynop: "Метеостанция",
  stationHumidity: "Влажность",
  stationPrecipitation: "Осадки",
  stationPressure: "Давление на станции",
  stationSeaLevelPressure: "Давление на уровне моря",
  stationSunshine: "Солнечное сияние",
  stationSnowDepth: "Высота снега",
  stationElevation: "Высота",
  stationOpenSounding: "Открыть зондирование",
  stationPinHere: "Закрепить здесь",
  fireTileTip: "Активные пожары (NASA FIRMS, последние 24 ч)",
  varFire: "ПОЖАРЫ",
  glyphFire: "F",
  fireDetection: "Активный пожар",
  fireAcquired: "Снято",
  fireRadiativePower: "Радиационная мощность",
  fireBrightness: "Яркостная температура",
  fireConfidence: "Достоверность",
  fireConfidenceLow: "низкая",
  fireConfidenceNominal: "номинальная",
  fireConfidenceHigh: "высокая",
  fireOverpass: "Пролёт",
  fireDay: "день",
  fireNight: "ночь",
  aqTileTip: "Станции качества воздуха (PM2.5)",
  varAq: "PM2.5",
  glyphAq: "Q",
  aqStation: "Качество воздуха",
  aqAgency: "Организация",
  aqNetwork: "Сеть",
  aqPreliminary: "Предварительные данные: не проверены, могут измениться",
  aqDayRange: "PM2.5, последние 24 ч",
  aqNearest: "Ближайшая станция качества воздуха, {km} км",
  alertsTileTip: "Действующие погодные предупреждения",
  varAlerts: "ПРЕДУПР.",
  glyphAlerts: "!",
  alertsCardTitle: "Предупреждения",
  alertsInForceNow: "Действуют сейчас",
  alertsAsOf: "на {time}",
  alertsLevel: "Уровень {level}",
  alertsUntilCancelled: "до отмены",
  alertsIssued: "выпущено {time}",
  alertCategoryRain: "Сильный дождь",
  alertCategoryFlood: "Наводнение",
  alertCategoryLandslide: "Оползень",
  alertCategoryWind: "Ветер",
  alertCategoryThunderstorm: "Гроза",
  alertCategorySnowIce: "Снег и гололёд",
  alertCategoryHeat: "Жара",
  alertCategoryCold: "Холод",
  alertCategoryFog: "Туман",
  alertCategoryDust: "Пыль",
  alertCategoryFire: "Пожароопасность",
  alertCategoryAir: "Качество воздуха",
  alertCategoryCoastal: "Побережье",
  alertCategoryMarine: "Море",
  alertCategoryTsunami: "Цунами",
  alertCategoryOther: "Прочее",
  markerPlace: "Место",
  markerEvent: "Событие",
  markerSources: "Источники",
  caseMarkersAria: "Места и события этого случая",
  casePartsAria: "Части этого события",
  riverHeading: "Расход рек",
  riverTracksAria: "Расчёт гидрологической модели",
  riverTrackAnalysis: "Анализ",
  riverTrackForecast: "Прогноз {cycle}",
  riverKeyAria: "Расход относительно обычного",
  riverRatio2: "< 2× обычного",
  riverRatio10: "2–10×",
  riverRatio100: "10–100×",
  riverRatioMax: "≥ 100×",
  riverKeyField: "Цвет по расходу, по шкале поля",
  riverExtents: "Зоны затопления",
  riverGaugeHint: "Круги — гидропосты: нажмите, чтобы увидеть гидрограф.",
  riverObserved: "измерено",
  riverModelled: "модель",
  riverPeaks: "Сообщённые пики",
  riverGaugeLoading: "загрузка…",
  riverGaugeUnavailable: "недоступно",

  soundingObserved: "НАБЛ",
  soundingModel: "МОДЕЛЬ",
  soundingNoModel: "нет модели в пределах 12 ч",
  soundingLoading: "Чтение зондирования…",
  soundingUnavailable: "Зондирование недоступно",
  soundingExpand: "Полный график",
  soundingClose: "Закрыть",
  soundingSheetHeading: "Зондирование",
  soundingSheetAria: "График зондирования",

  // The comparison page (compare.html).
  compareLink: "Сравнить",
  compareTitle: "Сравнить прогнозы",
  compareHeading: "Сравнение моделей",
  compareEyebrow: "точка",
  compareIntro:
    "Все действующие прогностические модели в одной точке, на одной шкале времени: что каждый выпуск даёт на ближайшие часы, рядом со сводками ближайшего аэропорта.",
  compareMetaDescription:
    "Сравните прогнозы GFS, ECMWF, AIFS, IFS HRES и HRRR в одной точке час за часом со сводками METAR ближайшего аэропорта.",
  compareLatitude: "Широта",
  compareLongitude: "Долгота",
  compareLocate: "Моё местоположение",
  compareLocateFailed: "Местоположение недоступно",
  compareOnMap: "На карте",
  compareSpan5: "5 дней",
  compareSpan15: "15 дней",
  compareFieldsAria: "Сравниваемые поля",
  compareModelsAria: "Блоки сравнения моделей",
  compareLoading: "Чтение {model}…",
  compareModelFailed: "{model}: {message}",
  compareOffGrid: "вне сетки этой модели",
  compareNoModels: "Ни одна модель не покрывает эту точку",
  compareHide: "Скрыть",
  compareShow: "Показать",
  comparePin: "Закрепить сверху",
  compareHidden: "Скрытые модели",
  compareRun: "Выпуск",
  compareObservationsFrom: "Сводки {icao}",
  compareNoAirport: "Нет аэропорта в пределах 40 км",
  compareHours: "Часы",
  compareNow: "сейчас",
  compareCells: "Каждое значение — ближайшая к точке ячейка собственной сетки модели, без интерполяции; время в вашем часовом поясе.",
  metricsMetaDescription: "Когда каждый прогностический прогон Xue выходил в эфир, по измерениям из рабочих процессов публикации: задержка после срока, пропущенные сроки и что было опубликовано к закрытию рынка на сутки вперёд ERCOT.",
  metricsHeading: "Прибытие прогонов",
  metricsEyebrow: "измерено",
  metricsIntro: "Когда каждый прогностический прогон появился на этом сайте, по собственным записям рабочих процессов публикации: момент записи живого указателя и сколько времени прошло от срока модели.",
  metricsNotSla: "Это измерения, а не уровень обслуживания: Xue не берёт обязательств по доступности.",
  metricsGenerated: "Создано {time}, последние {days} дн.",
  metricsLoading: "Чтение метрик…",
  metricsEmpty: "Метрик пока нет. Они строятся каждые шесть часов по рабочим процессам публикации; загляните после следующей сборки.",
  metricsFailed: "Не удалось прочитать метрики: {message}",
  metricsSourcesHeading: "По источникам",
  metricsLatencyNote: "Задержка отсчитывается от срока до момента публикации прогона, поэтому включает время расчёта самой модели. Всё время — UTC.",
  metricsTimelineNote: "Каждая полоса — всё окно: по столбику на каждый опубликованный срок, в его время, высота — задержка относительно наибольшей у источника; отметка под линией — срок, который так и не пришёл.",
  metricsTypicalNote: "* Типично у поставщика: опытная оценка того, когда данные модели обычно готовы после срока, а не измерение. Пусто, если оценки нет.",
  metricsTimelineAria: "Прибытия {model} за окно",
  metricsCadence: "каждые {hours} ч",
  metricsLatest: "Последний прогон",
  metricsLanded: "Опубликован",
  metricsLatency: "Задержка",
  metricsMedian: "Медиана",
  metricsMax: "Макс.",
  metricsTypical: "Типично у поставщика",
  metricsCycles: "Пришедшие сроки",
  metricsMissing: "Пропущено",
  metricsMissingList: "Пропущенные сроки",
  metricsRuns: "Запуски процесса",
  metricsOutcomeLanded: "опубликован",
  metricsOutcomeSkipped: "пропущен",
  metricsOutcomeDryRun: "пробный",
  metricsOutcomeFailed: "сбой",
  metricsBacklog: "Ещё не прочитано запусков процесса: {count}; следующая сборка их прочитает.",
  metricsDeadlinesHeading: "К крайнему сроку",
  metricsDeadlineIntro: "Для каждого местного дня — новейший прогон, уже опубликованный к крайнему сроку, и возраст его срока в тот момент.",
  metricsSource: "Источник",
  metricsCommonest: "Обычно",
  metricsNoneLive: "нет",
  glyphAurora: "A",
  varAurora: "ВЕРОЯТН",
  varDis06: "6Ч",
  varDisrp: "RP",
  varUpstream: "ПЛОЩ",
  fieldGroupSpace: "Космическая погода",
  fieldGroupFire: "Пожары",
  modelGroupForecast: "Модели прогноза",
  modelGroupRadar: "Радар",
  varLabelAurora: "Вероятность видимости полярного сияния",
  varLabelDis06: "Расход воды в реках (среднее за 6 ч)",
  varLabelDisrp: "Класс периода повторяемости",
  varLabelUpstream: "Площадь водосбора выше по течению",
  creditsAurora: "Космическая погода: вероятность полярного сияния, модель OVATION NOAA SWPC",
  creditsEfas: "Расход рек: Copernicus EMS EFAS v5, Европа 1′; только кейсы",
  creditsEra5: "Реанализ: Copernicus C3S ERA5 (ECMWF), глобально 0,25°, ежечасно, CC-BY-4.0; только кейсы",
  creditsCams: "Анализ аэрозолей: Copernicus CAMS (ECMWF), глобально 0,4°, каждые 3 часа, CC-BY-4.0; только кейсы",
};
